import { render, staticRenderFns } from "./questionView.vue?vue&type=template&id=96577c8e&scoped=true&"
import script from "./questionView.vue?vue&type=script&lang=js&"
export * from "./questionView.vue?vue&type=script&lang=js&"
import style0 from "./questionView.vue?vue&type=style&index=0&id=96577c8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96577c8e",
  null
  
)

export default component.exports